import React, { useState, useEffect, lazy, useCallback } from 'react';
import { useHistory, Redirect, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { Modal } from 'reactstrap';
import { confirmAlert } from 'react-confirm-alert';

// constants
import { commonRoutes, permissionRoutes } from '../routes.js';
import Loader from '../components/Common/Loader';
import LocalStrings from '../assets/languages';
import appIcons from '../constants/appIcons.js';
import {
  CDN_URL,
  INTERVAL_5,
  PORTAL_LOCALSTORAGE_ACCESS_KEY,
  PRIVACY_URL,
  TNC_URL
} from '../constants/constant.js';
import {
  checkValidURL,
  getAppTabId,
  getSameDomainBaseUrl,
  handleTrickyBoolean,
  isImage,
  isJSONParsable,
  isMandatoryProfileFieldEmpty,
  maintainResponseStructure,
  replaceAll
} from '../util/util-common.js';
import {
  ALLOWED_COOKIE_CONSENT_OPTIONS,
  ALLOWED_FEATURE_KEYS
} from '../constants/section-constants/common-constants.js';
import {
  showError,
  showSuccess
} from '../components/Common/alertmessage/index.js';
import {
  APPTABID_ROUTE_PATTERN,
  NOTREQUIRED_APPTABID_ROUTES,
  CONDITIONAL_COMMON_FEATURES
} from '../constants/section-constants/redirection-constants.js';
import {
  ALLOWED_FLASH_POPUPS,
  ALLOWED_POST_ANALYTICS_TYPES,
  MANDATORY_PROFILE_OPEN_TYPES,
  SITE_ACCESS_TYPES
} from '../constants/section-constants/type-constants.js';
import { loadFromLocalDB, setInLocalDB } from '../reducers/localStorage.js';
import { ALLOWED_SURVEY_FORM_SOURCES } from '../constants/section-constants/source-constant.js';
import {
  EVENT_SPECIFIC_CHECKING_CASES,
  checkEventSpecificCases
} from '../constants/section-constants/event-specific-checks.js';

// actions
import {
  fetchEventForms,
  checkToken,
  fetchEventContentTabs,
  fetchMyProfile,
  redirectingCalledFrom,
  fetchAdvertisements,
  fetchWebviewDetails,
  fetchTicketsForEvent,
  fetchTickets,
  postAnalytics,
  setSiteControl,
  mainLogout,
  fullScreenLoaderHandler,
  setProfilePortalToggle,
  updateAppuser,
  commonNetworkModal,
  handleProfileDetailsAfterSave,
  fetchUserAccessByRole,
  setAppFeaturesList,
  setRestrictAtEditProfile,
  setUnauthorisedApiCall
} from '../actions';

// components
import FourZeroFour from '../components/Common/pagenotfound.js';
import EventPortal from './components/EventPortal.js';
import ProfileAdminPortal from './components/ProfileAdminPortal.js';
import SignIn from '../components/Navbars/sign-in.js';
import SurveyForm from '../components/survey/components/survey-form.js';
import { renderFieldCheckboxWithOnChange } from '../components/Common/base-components.js';

const AdminLayout = props => {
  const {
    isLoggedIn,
    session,
    deviceSize,
    eventDetails,
    unAuthorizedApiCalled,
    show,
    eventTabs,
    sideAdvtList,
    surveyRecord,
    ticketsForEvent,
    incorrectEvent = false,
    siteControl,
    profileToggleReducer,
    signUpModalStatus,
    fullPageLoaderReducer,
    networkingReducer,
    userDetails,
    userDetailsAddOn,
    eventForms,
    userAccessByRole,
    tokenExpiryModalStatus,
    featureAppTabId,
    eventCustomSettings,
    groupIds,
    eventSettings
  } = props;

  const location = useLocation();
  const history = useHistory();
  const [isInvalidURL, setIsInvalidURL] = useState(false);
  const [renderSidebar, setRenderSidebar] = useState(true);
  const [sideAdPostAnalyticsCalled, setSideAdPostAnalyticsCalled] = useState(
    false
  );
  const [cookieState, setCookieState] = useState(false); // status => accept/denied
  const [nwLoading, setNWLoading] = useState(false);
  const [openCookieOptionSection, setCookieOptionSection] = useState(false);
  const [apptabCalled, setApptabCalled] = useState(0);
  const [routesNew, setRoutesNew] = useState(commonRoutes);
  const [routeIsSet, setRouteIsSet] = useState(0);
  const [triggerRoutesPrep, setTriggerRoutesPrep] = useState(0);
  const [allCookieOption, setAllCookieOption] = useState(
    ALLOWED_COOKIE_CONSENT_OPTIONS
  );
  const [showNoEventAccessModal, setShowNoEventAccessModal] = useState(false);

  // ----- Event related based details preparation
  useEffect(() => {
    if (
      !isLoggedIn &&
      !_.includes(window.location.hash, ALLOWED_FEATURE_KEYS.overview) &&
      !_.includes(window.location.hash, '#/autologin') &&
      !_.includes(window.location.hash, '#/sso-auth')
    )
      window.location.assign('#/overview');

    // ----------- setting dynamic event logo and name index.html head ------------
    let eventLogo = appIcons.eventifyFavIcon;

    if (!incorrectEvent && eventDetails?.eventicon) {
      eventLogo = CDN_URL + eventDetails?.eventicon;
      document.title = eventDetails?.eventname;
      setIsInvalidURL(false);
    } else if (incorrectEvent) {
      document.title = LocalStrings.dynamic.kSomethingWentWrongMsg;
      setIsInvalidURL(true);
    }

    const favicon = document.getElementById('favicon');
    favicon.href = eventLogo;
    // ------------------ dynamic event logo and name setting ends -----------------

    if (_.isEmpty(location?.search)) {
      if (isLoggedIn) {
        if (
          !_.includes(
            [
              '/myprofile',
              '/myprofile-exhibitor',
              '/myprofile-sponsor',
              '/myprofile-speaker',
              '/analytics'
            ],
            location.pathname
          )
        ) {
          _.isEmpty(userDetails) &&
            props.fetchMyProfile(session, null, eventForms);

          if (profileToggleReducer?.show) handleEditProfileToggle();
        } else if (!profileToggleReducer?.show) {
          const profileType = _.includes(
            ['/myprofile', '/analytics'],
            location.pathname
          )
            ? 'profile'
            : ALLOWED_FEATURE_KEYS[_.split(location.pathname, '-').pop()];
          handleEditProfileToggle(profileType);
        }
        props.fetchTickets(session, res => {});
      }
    }
  }, [location, incorrectEvent, eventDetails]);

  // ----- Manages site access based on client validity
  useEffect(() => {
    // --- Error message to show on unauthorized API call / 403 status
    if (unAuthorizedApiCalled) {
      showError(LocalStrings.dynamic.kSessionExpired);
      props.setUnauthorisedApiCall(false);
    }

    if (!_.isEmpty(eventDetails)) {
      // ----- Can't login, can access landing page
      if (_.isEqual(siteControl, SITE_ACCESS_TYPES.noAccess)) {
        if (!_.isEmpty(session?.sessionToken) && !showNoEventAccessModal) {
          setShowNoEventAccessModal(true);
          handleEditProfileToggle();
        }
      }
      // ----- Can not access site
      else if (_.isEqual(siteControl, SITE_ACCESS_TYPES.expired)) {
        // --- Redirecting to 404 page
        history.push('/fourzerofour'); // will show event has expired
        handleMainLogout();
      } else {
        // --- Common API calls
        _.isEmpty(eventTabs) &&
          apptabCalled < 2 &&
          props.fetchEventContentTabs(session, res => {
            setApptabCalled(prev => prev + 1);
          });

        // ----- Allow full site access
        !_.isEmpty(featureAppTabId.webview) &&
          props.fetchWebviewDetails(
            session,
            { apptabId: featureAppTabId.webview },
            res => {}
          );

        if (isLoggedIn) {
          props.fetchEventForms(session, res => {});
          props.fetchUserAccessByRole(session, eventTabs);
          if (!_.isEmpty(session.sessionToken) && _.isEmpty(ticketsForEvent))
            props.fetchTicketsForEvent(session, res => {});

          if (location.pathname.includes('/myprofile')) {
            handleEditProfileToggle('profile');
          } else if (
            location.pathname.includes('/mapdetails') ||
            location.pathname.includes('/newsdetails')
          ) {
            history.goBack();
          }
        }

        if (
          !_.includes(
            [SITE_ACCESS_TYPES.expired, SITE_ACCESS_TYPES.noAccess],
            siteControl
          ) &&
          !cookieState
        )
          handleCookieConsentPopup();
      }
    }
  }, [isLoggedIn, eventTabs, siteControl]);

  // ----- Manages site access for admin
  useEffect(() => {
    if (
      _.isEqual(siteControl, SITE_ACCESS_TYPES.restrict) &&
      isLoggedIn &&
      !location.pathname.includes('/myprofile')
    ) {
      handleEditProfileToggle('profile');
      if (session.isadmin) props.setSiteControl(SITE_ACCESS_TYPES.allowAdmin);
    }

    if (_.isEmpty(session?.sessionToken) && routeIsSet) {
      setRouteIsSet(0);
      props.setAppFeaturesList([]);
    }
  }, [session]);

  // ----- Manages the profile toggler
  useEffect(() => {
    if (!_.isEmpty(userDetails?.responses)) {
      props.handleProfileDetailsAfterSave(
        { ...userDetails, ...userDetailsAddOn },
        profileToggleReducer
      );
      props.fetchAdvertisements(session, { groupIds });
    }

    if (
      isLoggedIn &&
      !_.isEmpty(userDetails?.responses) &&
      (!location.pathname.includes('/myprofile') || !profileToggleReducer?.show)
    ) {
      // --- Edit profile redirect based on event settings
      const openEditProfile = !_.isNull(eventCustomSettings)
        ? _.isEqual(
            eventCustomSettings?.open_profile_after_login,
            MANDATORY_PROFILE_OPEN_TYPES.req
          ) && isMandatoryProfileFieldEmpty(userDetails, eventForms)
        : false;

      if (openEditProfile) {
        props.setRestrictAtEditProfile(true);
        handleEditProfileToggle('profile');
      } else props.setRestrictAtEditProfile(false);
    }
  }, [userDetails, isLoggedIn, location.pathname]);

  // ----- Event routes preparation based on user role access
  useEffect(() => {
    if (!eventTabs?.length || _.isEmpty(userDetails) || routeIsSet >= 2) return;

    let sortArrAvailable = [];

    if (
      _.includes(
        [SITE_ACCESS_TYPES.allow, SITE_ACCESS_TYPES.allowAdmin],
        siteControl
      )
    ) {
      // --- Extracting conditional common features event settings
      const userFeatures = !_.isNull(eventCustomSettings)
        ? eventCustomSettings?.user_feature
        : {};

      // --- Preparing allowed feature routes based on role-permission (userinfo)
      let local_routes = _.cloneDeep(permissionRoutes);
      let matched = [];
      _.map(local_routes, routeElement => {
        // --- Filtering enabled features for the selected event (App tabs)
        let match = _.filter(
          eventTabs,
          tabDetails =>
            tabDetails?.tabslected == routeElement.key && tabDetails?.isenabled
        );

        let obj = routeElement;

        // --- Portal supported tabs to render
        if (!_.isEmpty(match)) {
          matched.push(obj.key);

          if (match.length === 1) {
            match = match[0];

            // - check marked
            obj.checked = true;

            // - Tab details
            obj.name = match?.displaytabname;
            obj.display = match?.isenabled;
            obj.taborder = match?.taborder;
            obj.quicklinkorder = match?.quicklinkorder;

            // - Route handled for apptab ids
            if (!_.includes(NOTREQUIRED_APPTABID_ROUTES, obj.path))
              obj.path = _.replace(
                obj.path,
                APPTABID_ROUTE_PATTERN,
                `/${match?.apptabid}`
              );

            // - Tab icon (if custom one is used)
            if (!_.isEmpty(match?.iconimagepath)) {
              // Either font-awesome icon or image
              let iconVal = isJSONParsable(match?.iconimagepath)
                ? JSON.parse(match?.iconimagepath)
                : match?.iconimagepath;

              if (iconVal instanceof Object) {
                obj.iconType = 'fa-icon';
                obj.icon = iconVal?.title;
              } else if (isImage(iconVal) && obj.position !== 'top') {
                obj.iconType = 'image';
                obj.icon = `${CDN_URL}${iconVal}`;
              }
            }
            if (!_.isEmpty(match?.dark_iconimagepath)) {
              // Either font-awesome icon or image
              let iconVal = isJSONParsable(match?.dark_iconimagepath)
                ? JSON.parse(match?.dark_iconimagepath)
                : match?.dark_iconimagepath;

              if (iconVal instanceof Object) {
                obj.darkIconType = 'fa-icon';
                obj.darkIcon = iconVal?.title;
              } else if (isImage(iconVal) && obj.position !== 'top') {
                obj.darkIconType = 'image';
                obj.darkIcon = `${CDN_URL}${iconVal}`;
              }
            }

            // - Based on linked exh/spn and role-permissions, marking access for routes
            if (_.includes(CONDITIONAL_COMMON_FEATURES, match?.tabslected)) {
              obj.hasAccess =
                !_.isEmpty(userFeatures) &&
                !_.isNull(userFeatures[match?.tabslected])
                  ? userFeatures[match?.tabslected]
                  : false;
            } else if (
              _.isEqual(ALLOWED_FEATURE_KEYS.analytics, match?.tabslected) &&
              (!_.isNil(userDetails?.exhibitoridfk) ||
                !_.isNil(userDetails?.sponsoridfk))
            ) {
              obj.hasAccess = true;
            } else if (_.isEmpty(userAccessByRole?.features)) {
              obj.hasAccess = true;
            } else if (!_.isEmpty(userAccessByRole?.features)) {
              let featureAccess = _.find(
                userAccessByRole?.features,
                (tabDetails, tabId) => {
                  if (match.apptabid == tabId) return true;
                  else if (
                    _.includes(['qr', 'scanning'], tabId) &&
                    _.isEqual(obj?.key, ALLOWED_FEATURE_KEYS.scans)
                  ) {
                    return true;
                  } else return false;
                }
              );

              obj.hasAccess = !_.isEmpty(featureAccess);
            }
          } else {
            _.map(match, apptab => {
              let newRouteElement = _.clone(routeElement);

              // check marked
              newRouteElement.checked = true;

              // - Tab details
              newRouteElement.name = apptab?.displaytabname;
              newRouteElement.display = apptab?.isenabled;
              newRouteElement.taborder = apptab?.taborder;
              newRouteElement.quicklinkorder = apptab?.quicklinkorder;
              if (
                !_.includes(NOTREQUIRED_APPTABID_ROUTES, newRouteElement.path)
              )
                newRouteElement.path = _.replace(
                  newRouteElement.path,
                  APPTABID_ROUTE_PATTERN,
                  `/${apptab?.apptabid}`
                );

              // - Tab icon (if custom one is used)
              if (!_.isEmpty(apptab?.iconimagepath)) {
                // Either font-awesome icon or image
                let iconVal = isJSONParsable(apptab?.iconimagepath)
                  ? JSON.parse(apptab?.iconimagepath)
                  : apptab?.iconimagepath;

                if (iconVal instanceof Object) {
                  newRouteElement.iconType = 'fa-icon';
                  newRouteElement.icon = iconVal?.title;
                } else if (isImage(iconVal)) {
                  newRouteElement.iconType = 'image';
                  newRouteElement.icon = `${CDN_URL}${iconVal}`;
                }
              }
              if (!_.isEmpty(apptab?.dark_iconimagepath)) {
                // Either font-awesome icon or image
                let iconVal = isJSONParsable(apptab?.dark_iconimagepath)
                  ? JSON.parse(apptab?.dark_iconimagepath)
                  : apptab?.dark_iconimagepath;

                if (iconVal instanceof Object) {
                  newRouteElement.darkIconType = 'fa-icon';
                  newRouteElement.darkIcon = iconVal?.title;
                } else if (isImage(iconVal)) {
                  newRouteElement.darkIconType = 'image';
                  newRouteElement.darkIcon = `${CDN_URL}${iconVal}`;
                }
              }

              if (_.isEmpty(userAccessByRole?.features))
                newRouteElement.hasAccess = true;
              else if (!_.isEmpty(userAccessByRole)) {
                let featureAccess = _.find(
                  userAccessByRole?.features,
                  (tabDetails, tabId) => apptab.apptabid == tabId
                );

                newRouteElement.hasAccess = !_.isEmpty(featureAccess);
              }

              if (!_.includes(local_routes, newRouteElement))
                local_routes.push(newRouteElement);
            });
          }
        } else {
          obj.name = LocalStrings.dynamic[routeElement.languageKey];
          obj.display = routeElement.display;
          obj.taborder = -1;
          obj.quicklinkorder = -1;

          if (_.isEqual(ALLOWED_FEATURE_KEYS.agenda, routeElement.key)) {
            const meetingFeaturePresent = !_.isEmpty(
              _.filter(
                eventTabs,
                tabDetails =>
                  _.isEqual(
                    ALLOWED_FEATURE_KEYS.meetings,
                    tabDetails?.tabslected
                  ) && tabDetails?.isenabled
              )
            );
            const scheduleFeaturePresent = !_.isEmpty(
              _.filter(
                eventTabs,
                tabDetails =>
                  _.isEqual(
                    ALLOWED_FEATURE_KEYS.schedule,
                    tabDetails?.tabslected
                  ) && tabDetails?.isenabled
              )
            );
            obj.hasAccess = meetingFeaturePresent || scheduleFeaturePresent;
          }
        }
      });
      sortArrAvailable = _.sortBy(local_routes, 'taborder', 'asc');
    }

    const local_commonRoutes = _.chain(commonRoutes)
      .map(routeItem => {
        return {
          ...routeItem,
          name: LocalStrings.dynamic[routeItem?.languageKey]
        };
      })
      .value();

    // local state to maintain children layout components
    setRoutesNew([...local_commonRoutes, ...sortArrAvailable]);
    setRouteIsSet(prev => prev + 1);

    // redux to access centrally
    let local_appFeatureList = [];
    _.map(sortArrAvailable, feature => {
      let local_feature = _.omit(feature, ['component']);
      local_appFeatureList.push(local_feature);
    });
    props.setAppFeaturesList(local_appFeatureList);
  }, [
    eventTabs,
    userDetails,
    siteControl,
    userAccessByRole,
    triggerRoutesPrep
  ]);

  const handleCookieConsentPopup = () => {
    // ----- Cookie consent
    const flashPopupDetails = loadFromLocalDB(
      PORTAL_LOCALSTORAGE_ACCESS_KEY.flashPopups
    );

    if (_.isEmpty(flashPopupDetails)) {
      setInLocalDB({
        key: PORTAL_LOCALSTORAGE_ACCESS_KEY.flashPopups,
        value: _.cloneDeep(ALLOWED_FLASH_POPUPS.payload)
      });
      setTimeout(() => {
        setCookieState(true);
      }, INTERVAL_5);
    } else if (!_.isEmpty(flashPopupDetails)) {
      if (_.isEmpty(flashPopupDetails[ALLOWED_FLASH_POPUPS.types.privacy])) {
        let payloadValue = _.cloneDeep(flashPopupDetails);
        payloadValue[ALLOWED_FLASH_POPUPS.types.privacy] =
          ALLOWED_FLASH_POPUPS.privacyTypes[0];
        setInLocalDB({
          key: PORTAL_LOCALSTORAGE_ACCESS_KEY.flashPopups,
          value: payloadValue
        });
        setTimeout(() => {
          setCookieState(true);
        }, INTERVAL_5);
      }
    }
  };

  const handleSideMenuAdAnalytics = () => {
    let promiseArr = [];
    _.map(sideAdvtList, thisAd => {
      promiseArr.push(
        new Promise((resolve, reject) => {
          props.postAnalytics(
            session,
            [
              ALLOWED_POST_ANALYTICS_TYPES.screen.sidemenu,
              ALLOWED_POST_ANALYTICS_TYPES.type.adView,
              thisAd.advtid,
              null,
              0
            ],
            res => {
              resolve();
            }
          );
        })
      );
    });

    Promise.all(promiseArr);
  };

  const handleNetworkStatusUpdate = (val = true) => {
    setNWLoading(true);

    let dataObj = {
      eventid: session?.eventid,
      isnetworking: val ? 1 : 0
    };
    let formRes = JSON.parse(userDetails?.responses);
    _.map(formRes, field => {
      if (field.name == 'isnetworking') {
        field.value = val;
      }
    });
    dataObj.responses = JSON.stringify(maintainResponseStructure(formRes));

    props.updateAppuser(session, dataObj, response => {
      setNWLoading(false);

      if (response.success) {
        showSuccess(LocalStrings.dynamic.kProfileUpdated);
      } else {
        showError(LocalStrings.dynamic.kSomethingWentWrongMsg);
      }
    });
  };

  const handleEditProfileToggle = (type = null) => {
    if (siteControl === SITE_ACCESS_TYPES.noAccess) {
      if (location.pathname !== '/overview') history.push('/overview');
      if (profileToggleReducer?.show)
        props.setProfilePortalToggle({
          show: false,
          type: '',
          data: null,
          active_tab: null,
          sections: [],
          activeIndex: null
        });
    } else if (
      _.includes(
        [
          'profile',
          ALLOWED_FEATURE_KEYS.exhibitor,
          ALLOWED_FEATURE_KEYS.speaker,
          ALLOWED_FEATURE_KEYS.sponsor
        ],
        type
      )
    ) {
      props.setProfilePortalToggle(
        userDetails,
        type === 'profile' ? 'profile' : type
      );

      const path = type === 'profile' ? `/myprofile` : `/myprofile-${type}`;
      history.push({
        pathname: path
      });
    } else {
      setRouteIsSet(prev => prev - 1);
      setTriggerRoutesPrep(prev => prev + 1);
      props.setAppFeaturesList([]);

      if (profileToggleReducer?.show) {
        history.push('/overview');

        props.setProfilePortalToggle({
          show: false,
          type: '',
          data: null,
          active_tab: null,
          sections: [],
          activeIndex: null
        });
      } // else already in event portal
    }
  };

  // Opens confirmation popup, calls handleMainLogout if confirmed
  const handleAppLogout = () => {
    confirmAlert({
      title: LocalStrings.dynamic.kLogoutText,
      message: `${LocalStrings.dynamic.kLogoutConfirm}?`,
      buttons: [
        {
          label: _.startCase(_.toLower(LocalStrings.dynamic.kYesText)),
          onClick: () => {
            handleMainLogout();

            history.push({
              pathname: '/overview'
            });
          }
        },
        {
          label: LocalStrings.dynamic.kNoTextLC,
          onClick: () => {}
        }
      ]
    });
  };

  const handleMainLogout = (isTokenExp = false) => {
    props.mainLogout(session, { isTokenExp });

    if (profileToggleReducer?.show) {
      props.setProfilePortalToggle({
        show: false,
        type: '',
        data: null,
        active_tab: null,
        sections: [],
        activeIndex: null
      });
    }

    if (showNoEventAccessModal) setShowNoEventAccessModal(false);
  };

  if (!_.isEmpty(sideAdvtList) && isLoggedIn && !sideAdPostAnalyticsCalled) {
    handleSideMenuAdAnalytics();
    setSideAdPostAnalyticsCalled(true);
  }

  const _renderAppWithLayout = useCallback(() => {
    return profileToggleReducer?.show ? (
      <ProfileAdminPortal
        {...props}
        routesNew={routesNew}
        handleEditProfileToggle={handleEditProfileToggle}
        handleAppLogout={handleAppLogout}
      />
    ) : (
      <EventPortal
        {...props}
        // ----- States
        routesNew={routesNew}
        renderSidebar={renderSidebar}
        setRenderSidebar={setRenderSidebar}
        sideAdPostAnalyticsCalled={sideAdPostAnalyticsCalled}
        setSideAdPostAnalyticsCalled={setSideAdPostAnalyticsCalled}
        // ----- Custom functions
        handleEditProfileToggle={handleEditProfileToggle}
        handleAppLogout={handleAppLogout}
      />
    );
  }, [
    profileToggleReducer?.show,
    routesNew,
    isLoggedIn,
    isInvalidURL,
    renderSidebar,
    sideAdPostAnalyticsCalled
  ]);

  const _renderCookiePopup = useCallback(() => {
    const allCustomOptsClicked = !_.filter(allCookieOption, opt => !opt.checked)
      .length;

    const handleFooterRedirection = type => {
      checkValidURL(
        _.isEqual(type, 'terms')
          ? eventSettings?.termsandconditions
          : eventSettings?.privacy
      )
        ? window.open(
            _.isEqual(type, 'terms')
              ? eventSettings?.termsandconditions
              : eventSettings?.privacy,
            '_blank'
          )
        : window.open(
            replaceAll(
              _.isEqual(type, 'terms') ? TNC_URL : PRIVACY_URL,
              ['###BASE_URL###'],
              [getSameDomainBaseUrl(session)]
            ),
            '_blank'
          );
    };

    const handleAction = type => {
      if (_.includes(ALLOWED_FLASH_POPUPS.privacyTypes, type)) {
        const flashPopupDetails = loadFromLocalDB(
          PORTAL_LOCALSTORAGE_ACCESS_KEY.flashPopups
        );
        let payloadValue = _.cloneDeep(ALLOWED_FLASH_POPUPS.payload);

        if (_.isEmpty(flashPopupDetails)) {
          payloadValue[ALLOWED_FLASH_POPUPS.types.privacy] = type;
        } else {
          payloadValue = _.cloneDeep(flashPopupDetails);
          payloadValue[ALLOWED_FLASH_POPUPS.types.privacy] = type;
        }

        setInLocalDB({
          key: PORTAL_LOCALSTORAGE_ACCESS_KEY.flashPopups,
          value: payloadValue
        });
      }

      if (_.isEqual(ALLOWED_FLASH_POPUPS.privacyTypes[2], type)) {
        let localState = loadFromLocalDB(PORTAL_LOCALSTORAGE_ACCESS_KEY.state);

        localState.session.emailid = '';
        localState.session.firstname = '';
        localState.session.lastname = '';

        setInLocalDB({
          key: PORTAL_LOCALSTORAGE_ACCESS_KEY.state,
          value: localState
        });
      }

      setCookieState(false);
    };

    const handleCheckboxChange = key => {
      let localArr = _.cloneDeep(allCookieOption);
      localArr[key].checked = !localArr[key].checked;
      setAllCookieOption(localArr);
    };

    return (
      <Modal
        className="gdpr-consent-modal"
        isOpen={cookieState}
        size="md"
        centered
      >
        <div className="modal-body">
          <div className="d-flex flex-column" style={{ gap: '1.5rem' }}>
            <div className="cookie-consent">
              <span className="w-100 d-flex justify-content-between">
                <img src={appIcons.cookieIcon} alt="cookie goes here" />
              </span>
              <span
                className="custom-text8-medium-primary"
                style={{ fontWeight: '700' }}
              >
                {LocalStrings.dynamic.kCookieConsentTitle}
              </span>

              {/* --- message --- */}
              <span className="custom-text8-normal-primary">
                {LocalStrings.dynamic.kCookieConsentMessage}
                <span
                  className="custom-text1-medium-secondary-link"
                  onClick={() => handleFooterRedirection('privacy')}
                >
                  {LocalStrings.dynamic.KPrivacyPolicy},
                </span>
                <span
                  className="custom-text1-medium-secondary-link"
                  onClick={() => handleFooterRedirection('terms')}
                >
                  {' '}
                  {LocalStrings.dynamic.kTermsAndConditions}.
                </span>
              </span>
            </div>

            {/* --- Buttons --- */}
            <div className="d-flex flex-column" style={{ gap: '0.5rem' }}>
              <div className="d-flex" style={{ gap: '1rem' }}>
                {/* - Necessary - */}
                <div className="w-50">
                  <button
                    className="w-100 custom-button-outerline-primary-md"
                    onClick={() =>
                      handleAction(ALLOWED_FLASH_POPUPS.privacyTypes[2])
                    }
                  >
                    {LocalStrings.dynamic.kCookieConsentAcceptNecessary}
                  </button>
                </div>

                {/* - Custom - */}
                <div className={`${deviceSize.isMobile ? 'd-none' : 'w-50'}`}>
                  <button
                    className="w-100 custom-button-outerline-primary-md"
                    onClick={() => {
                      setCookieOptionSection(true);
                    }}
                  >
                    {LocalStrings.dynamic.kCookieConsentIWillChoose}
                  </button>
                </div>

                {/* - All - */}
                <div className="w-50">
                  <button
                    className={`w-100 ${checkEventSpecificCases(
                      session?.eventid,
                      EVENT_SPECIFIC_CHECKING_CASES.cookieButtonSameClass
                    )}`}
                    onClick={() =>
                      handleAction(ALLOWED_FLASH_POPUPS.privacyTypes[1])
                    }
                  >
                    {LocalStrings.dynamic.kCookieConsentAcceptAll}
                  </button>
                </div>
              </div>

              {deviceSize.isMobile && (
                <button
                  className="w-100 custom-button-outerline-primary-md"
                  onClick={() => {
                    setCookieOptionSection(true);
                  }}
                >
                  {LocalStrings.dynamic.kCookieConsentIWillChoose}
                </button>
              )}
            </div>

            {/* Checkbox Section */}
            {openCookieOptionSection && (
              <>
                <div className="col-12 px-0">
                  <div
                    className="d-flex flex-wrap"
                    style={{ width: '100%', gap: '0.5rem' }}
                  >
                    {_.map(allCookieOption, (optData, optKey) => (
                      <div
                        key={`cookie_opt_${optKey}`}
                        className="d-flex justify-content-start"
                        style={{
                          gap: '10px'
                        }}
                      >
                        {renderFieldCheckboxWithOnChange({
                          label: optData.text,
                          type: 'checkbox',
                          checked: allCookieOption[optKey].checked,
                          onChange: () => handleCheckboxChange(optKey)
                        })}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Accept Selection Button */}
                <button
                  className="w-50 custom-button-outerline-primary-md"
                  onClick={() =>
                    handleAction(
                      ALLOWED_FLASH_POPUPS.privacyTypes[
                        allCustomOptsClicked ? 1 : 2
                      ]
                    )
                  }
                >
                  {LocalStrings.dynamic.kCookieConsentAcceptSelection}
                </button>
              </>
            )}
          </div>
        </div>
      </Modal>
    );
  }, [
    cookieState,
    eventDetails,
    session,
    isLoggedIn,
    openCookieOptionSection,
    allCookieOption
  ]);

  return (
    <>
      {isInvalidURL ? (
        <FourZeroFour noPage />
      ) : (
        <>
          {siteControl === SITE_ACCESS_TYPES.expired ? (
            <div
              className="d-flex flex-column justify-content-center align-items-center w-100"
              style={{
                height: '100vh',
                gap: '1rem'
              }}
            >
              <span className="custom-text2-medium-primary">
                {LocalStrings.dynamic.kValidityExpireTitle}
              </span>
              <span className="custom-text1-normal-secondary">
                {LocalStrings.dynamic.kValidityExpireMessage}
              </span>
            </div>
          ) : location?.pathname == '/' ? (
            <Redirect from="/" to="/overview" />
          ) : (
            _renderAppWithLayout()
          )}

          {/* ---------------- Popup sections start ---------------- */}
          {/* ------ Login popup ------ */}
          {signUpModalStatus?.showModal && <SignIn history={history} />}
          {/* ------ Screen blocking common loader ------ */}
          {fullPageLoaderReducer && (
            <Modal
              className=""
              contentClassName="custom-loader-content-class"
              isOpen={fullPageLoaderReducer}
              size="sm"
              centered
            >
              <Loader />
            </Modal>
          )}
          {/* ------ Cookie consent popup ------ */}
          {cookieState && _renderCookiePopup()}

          {/* ----- Waitlist and inactive user blocker - N/W - Mandatory survey - Session token expired ----- */}
          {_.isEmpty(userDetails) ? (
            <></>
          ) : handleTrickyBoolean(userDetailsAddOn?.isactive) &&
            !handleTrickyBoolean(userDetailsAddOn?.userwaitlistmode) ? (
            <>
              {/* ----- networking popup modal ----- */}
              {networkingReducer && (
                <Modal
                  className="gdpr-consent-modal"
                  isOpen={networkingReducer}
                  size="md"
                  centered
                >
                  <div className="modal-body">
                    <div className="row mx-0" style={{ gap: 12 }}>
                      {/* --- Header --- */}
                      <div className="col-12 px-0 d-flex justify-content-between align-items-center">
                        <div className="modal-title custom-text2-medium-primary">
                          {LocalStrings.dynamic.kGDPRConsentTitleText}
                        </div>
                        <button
                          aria-label="Close"
                          className="close"
                          data-dismiss="modal"
                          type="button"
                          onClick={() => props.commonNetworkModal(false)}
                        >
                          <span className="font-icomoon custom-text4-medium-primary">
                            {appIcons.crossIcon}
                          </span>
                        </button>
                      </div>

                      {/* --- Desc text --- */}
                      <div className="col-12 px-0">
                        <div className="custom-text1-normal">
                          {LocalStrings.dynamic.KGDRPConsentDescription}
                        </div>
                      </div>

                      {/* --- NW Toggle --- */}
                      <div
                        className="col-12 p-3 d-flex align-items-center rounded bg-offWhite"
                        style={{
                          gap: 12,
                          cursor: nwLoading ? 'progress' : 'pointer'
                        }}
                      >
                        <label className="switch-md mb-0">
                          <input
                            type="checkbox"
                            checked={userDetailsAddOn?.isnetworking}
                            onChange={e =>
                              handleNetworkStatusUpdate(e.target.checked)
                            }
                            disabled={nwLoading}
                          />
                          <span className="slider-md round"></span>
                        </label>

                        {/* - Switch indicator - */}
                        <span className="custom-text8-normal-secondary">
                          {userDetailsAddOn?.isnetworking
                            ? LocalStrings.dynamic.kNetworkingIsOn
                            : LocalStrings.dynamic.kNetworkingIsOff}
                        </span>
                      </div>

                      <div
                        className="col-12 p-3"
                        style={{
                          background: 'var(--confirm-green-bg)'
                        }}
                      >
                        <span className="custom-text8-normal-green">
                          {LocalStrings.dynamic.kGDPRNoteText}
                        </span>
                      </div>
                    </div>
                  </div>
                </Modal>
              )}
              {/* ----- Survey popup ----- */}
              {!_.isEmpty(surveyRecord?.mandatory) && (
                <Modal
                  isOpen={!_.isEmpty(surveyRecord?.mandatory)}
                  size="md"
                  centered
                  backdrop={'static'}
                  keyboard={false}
                >
                  <div className="modal-header d-flex justify-content-between align-items-center">
                    <div className="modal-title custom-text2-medium-primary">
                      {surveyRecord?.mandatory?.formname}
                    </div>
                  </div>

                  <div className="modal-body">
                    <div
                      className="scrollbar-hide-no-maxheight"
                      style={{ height: deviceSize.height - 240 }}
                    >
                      <SurveyForm
                        source={ALLOWED_SURVEY_FORM_SOURCES.mandatory}
                        refresh={true}
                      />
                    </div>
                  </div>
                </Modal>
              )}
              {/* ----- Session token expiry - No site access modal ----- */}
              {(tokenExpiryModalStatus || showNoEventAccessModal) && (
                <Modal
                  className="gdpr-consent-modal"
                  isOpen={tokenExpiryModalStatus || showNoEventAccessModal}
                  size="md"
                  centered
                >
                  <div className="modal-body">
                    <div className="row mx-0" style={{ gap: 12 }}>
                      {/* --- Header --- */}
                      <div className="col-12 px-0 d-flex justify-content-between align-items-center">
                        <div className="modal-title custom-text2-medium-primary">
                          {LocalStrings.dynamic.kLogoutText}
                        </div>
                      </div>

                      {/* --- Desc text --- */}
                      <div className="col-12 px-0">
                        <div className="custom-text1-normal">
                          {tokenExpiryModalStatus
                            ? LocalStrings.dynamic.kSessionExpired
                            : LocalStrings.dynamic.kEventNotStarted}
                        </div>
                      </div>

                      {/* --- Buttons --- */}
                      <div
                        className="col-12 px-0 d-flex"
                        style={{ gap: '1rem' }}
                      >
                        <button
                          className="custom-button-primary-md"
                          onClick={() => handleMainLogout(true)}
                        >
                          {LocalStrings.dynamic.kAccessUnderstand}
                        </button>
                      </div>
                    </div>
                  </div>
                </Modal>
              )}
            </>
          ) : (
            <>
              {/* ----- Waitlist / Inactive user blocker modal ----- */}
              <Modal
                className="gdpr-consent-modal"
                isOpen={_.isEmpty(session?.sessionToken)}
                size="md"
                centered
              >
                <div className="modal-body">
                  <div className="row mx-0" style={{ gap: 12 }}>
                    {/* --- Header --- */}
                    <div className="col-12 px-0 d-flex justify-content-between align-items-center">
                      <div className="modal-title custom-text2-medium-primary">
                        {LocalStrings.dynamic.kInformationText}
                      </div>
                    </div>

                    {/* --- Desc text --- */}
                    <div className="col-12 px-0">
                      <div className="custom-text1-normal">
                        {LocalStrings.dynamic.kInActiveUserMsg}
                      </div>
                    </div>

                    {/* --- Buttons --- */}
                    <div
                      className="col-12 px-0 custom-button-primary-md d-flex justify-content-center align-items-center cursor-pointer"
                      onClick={() => handleMainLogout(true)}
                    >
                      <span className="">{LocalStrings.dynamic.kOk}</span>
                    </div>
                  </div>
                </div>
              </Modal>
            </>
          )}
          {/* ----------------- Popup sections end ----------------- */}
        </>
      )}
    </>
  );
};

const mapStateToProps = state => {
  const sideAdvtList = !_.isEmpty(state.advtDetails)
    ? _.filter(state.advtDetails, advt => _.isEqual(advt?.screen, 'sidemenu'))
    : [];
  const featureAppTabId = {
    webview: getAppTabId(state.eventTabs, ALLOWED_FEATURE_KEYS.webview)
  };

  const groupIds = _.split(state.userDetails?.usercategory, ',').map(ea =>
    Number(ea)
  );

  return {
    isLoggedIn: state.isLoggedIn,
    session: state.session,
    show: state.showSidebar,
    eventTabs: state.eventTabs,
    deviceSize: state.deviceSize,
    surveyRecord: state.surveyRecord,
    eventDetails: state.eventDetails,
    unAuthorizedApiCalled: state.unAuthorizedApiCalled,
    siteControl: state.siteControlReducer,
    profileToggleReducer: state.profileToggleReducer,
    signUpModalStatus: state.loginModalReducer,
    fullPageLoaderReducer: state.fullPageLoaderReducer,
    networkingReducer: state.networkingReducer,
    userDetails: state.userDetails,
    userDetailsAddOn: state.userDetailsAddOn,
    eventForms: state.eventForms,
    userAccessByRole: state.userAccessByRole,
    tokenExpiryModalStatus: state.tokenExpiryModalStatus,
    ticketsForEvent: state.ticketsForEvent,
    eventCustomSettings: state.eventSettings?.custom_settings,
    eventSettings: state.eventSettings,
    sideAdvtList,
    featureAppTabId,
    groupIds
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchEventForms,
      checkToken,
      fetchEventContentTabs,
      fetchMyProfile,
      redirectingCalledFrom,
      fetchAdvertisements,
      fetchWebviewDetails,
      fetchTicketsForEvent,
      fetchTickets,
      postAnalytics,
      setSiteControl,
      mainLogout,
      fullScreenLoaderHandler,
      setProfilePortalToggle,
      updateAppuser,
      commonNetworkModal,
      handleProfileDetailsAfterSave,
      fetchUserAccessByRole,
      setAppFeaturesList,
      setRestrictAtEditProfile,
      setUnauthorisedApiCall
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AdminLayout);
